export const colors = {
  primaryColor: "#ffffff",
  secondaryColor: "#159AA8",
  halGray: "#878787",
  halLightGray: "#F7F7F7",
  black100: "#1c1c1c",
};
